<template>
  <div class="TokenValidationComponent">
    <div class="code">
      <div class="header">
        <a class="back" @click="$emit('back')">
          <BaseIcon name="arrow-back-mono" />
        </a>
        <Button type="ghost" size="small" @click="openModal">
          Não recebi meu código
        </Button>
      </div>
      <h1 class="title">Código de acesso</h1>
      <p class="text">
        Por favor, digite o código de acesso que enviamos para o seu número /
        e-mail .
        <br />
        Isso pode levar alguns segundos.
      </p>

      <TokenInput :invalid-code="invalid" @submit="verifyToken" />
      <!-- action -->
      <div class="actions">
        <Button type="primary" :busy="busy" @click="verifyToken">
          Acessar
        </Button>
      </div>

      <Dialog
        :display="displayDialog"
        :hide-close-button="true"
        :persisted="busy"
        @close="displayDialog = false"
      >
        <template #header-title>Deseja reenviar o código?</template>
        <template #content>
          <p class="text" style="max-width: 540px">
            Ao reenviar o código de acesso, você receberá em seu número /
            e-mail.
            <br />
            Isso pode levar alguns segundos.
          </p>
          <p class="text" style="max-width: 540px">
            Se ainda não receber, você pode
            <BaseLink @click="$router.push('/obter-ajuda')">
              obter ajuda
            </BaseLink>
            da nossa equipe.
          </p>
        </template>
        <template #footer>
          <Button type="primary" :busy="busy" @click="resend">
            Sim, reenviar código
          </Button>
          <Button type="ghost" :busy="busy" @click="displayDialog = false">
            Cancelar
          </Button>
        </template>
      </Dialog>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { HttpStatusCode } from '@/helpers/jb-error'
import BaseLink from '@/aasgard/components/base/BaseLink.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'
import Button from '@/aasgard/components/buttons/Button.vue'
import TokenInput from '@/components/commomComponents/inputs/TokenInput.vue'
export default {
  name: 'TokenValidationComponent',
  components: {
    BaseLink,
    Dialog,
    BaseIcon,
    Button,
    TokenInput,
  },
  props: {
    fieldValue: { type: String, default: '' },
    userEmail: { type: String, default: '' },
    userNumber: { type: String, default: '' },
    loginMethod: { type: String, default: '' },
  },
  emits: ['back', 'login'],
  data() {
    return {
      displayDialog: false,
      busy: false,
      invalid: false,
    }
  },
  methods: {
    ...mapActions({
      actTokenLogin: 'token/actTokenLogin',
      actTokenVerify: 'token/actTokenVerify',
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    openModal() {
      this.displayDialog = true
      this.busy = false
      this.actEmitGaEvent({
        eventCategory: 'tela-de-login',
        eventAction: 'clique-nao-recebi-meu-codigo',
        eventLabel: 'clique-nao-recebi-meu-codigo',
      })
    },
    async resend() {
      this.busy = true
      this.actEmitGaEvent({
        eventCategory: 'tela-de-login',
        eventAction: 'clique-reenviar-codigo',
        eventLabel: 'clique-reenviar-codigo',
      })
      try {
        await this.actTokenLogin({
          tokenRequest: {
            [this.loginMethod]: this.fieldValue,
            send_sms: true,
          },
        })
        this.displayDialog = false
      } catch (e) {
        return e
      }

      this.busy = false
    },
    async verifyToken(token) {
      let data

      this.invalid = false
      this.busy = true

      if (this.loginMethod === 'email') {
        data = {
          email: this.fieldValue,
        }
      } else {
        data = {
          cpf: this.fieldValue.replace(/\D/g, ''),
        }
      }

      try {
        const response = await this.actTokenVerify({
          keep_authenticated: 'false',
          token,
          ad_campaign: sessionStorage.getItem('utm_campaign') || '',
          ad_source: sessionStorage.getItem('utm_source') || '',
          ...data,
        })
        const { status } = response || {}
        if (status === HttpStatusCode.OK) {
          this.actEmitGaEvent({
            eventCategory: 'tela-de-login',
            eventAction: 'login-realizado',
            eventLabel: 'login-realizado',
          })
          this.$emit('login')
        } else if (
          status === HttpStatusCode.UNAUTHORIZED ||
          status === HttpStatusCode.BAD_REQUEST
        ) {
          this.invalid = true
        }
      } catch (e) {
        this.invalid = true
      }

      this.busy = false
    },
  },
}
</script>
<style lang="scss">
// SASS

.TokenValidationComponent {
  display: flex;
  justify-content: center;
  background-color: white;
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;

  & > .code {
    display: flex;
    flex-direction: column;

    & > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding: 16px 0;

      & > .back {
        align-items: center;
        justify-content: center;
      }

      & > p {
        @include body-2;
        text-align: right;
        color: $color-brand-primary;

        &:hover {
          text-decoration-line: underline;
          color: $color-brand-primary-dark;
          cursor: pointer;
        }
      }
    }

    & > .title {
      @include headline-5;
      color: $color-black-high;
      margin: 0 0 16px 0;
    }

    & > .text {
      @include body-1;
      color: $color-black-medium;
      margin: 0 0 24px 0;

      & > strong {
        color: $color-black-high;
        font-weight: 600;
      }
    }

    & > .TokenInput {
      margin: 0 0 8px 0;
    }

    & > .actions {
      padding: 16px 0;
      display: flex;
      flex-direction: column;

      & > .Button {
        width: 100%;
      }
    }

    & > .Dialog {
      p {
        @include body-1;
        color: $color-black-medium;

        & > strong {
          color: $color-black-high;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
